import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot, UrlTree } from '@angular/router';
import { SecurityService } from './security.service';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

export const ClientGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> => {
  return inject(SecurityService).canActivate(next, state);
  //return true;
};
